var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"mt-3"},[_c('EditProfileForm'),_c('card',{staticClass:"mt-3"},[_c('RecoverPassword')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }